import Group from '@pinecast/common/Group';
import type {CSS} from '@pinecast/styles';
import styled, {useColors} from '@pinecast/styles';
import * as React from 'react';

const Text = styled('span');

type Props = {
  children: React.ReactNode;
  message: React.ReactNode;
  position?: 'left' | 'right';
  style?: CSS;
  type?: 'positive' | 'negative';
};

const ButtonLabel = ({
  children,
  message,
  position = 'right',
  style,
  type,
}: Props) => {
  const designColors = useColors();
  return (
    <Group spacing={8} centerChildren wrapperStyle={style}>
      {position === 'right' && <>{children}</>}
      {message != null && (
        <Text
          style={{
            color:
              type === 'positive'
                ? designColors.badgeGreenText
                : type === 'negative'
                  ? designColors.badgeRedText
                  : designColors.badgeGrayText,
            fontSize: 14,
          }}
        >
          {message}
        </Text>
      )}
      {position === 'left' && <>{children}</>}
    </Group>
  );
};

export default ButtonLabel;
